import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { PageRouteBuilder } from "@common/route/page-route-builder";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";

@Component({
    selector: "adapt-global-ai-usage-page",
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./global-ai-usage-page.component.html",
})
export class GlobalAiUsagePageComponent extends BaseRoutedComponent implements OnInit {
    public constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}

export const globalAiUsagePageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-global-ai-usage-page", GlobalAiUsagePageComponent)
    .atUrl("/tools/ai-usage")
    .withTitle("AI Usage")
    .build();
